
<template>
    <div>
        <v-layout align-center justify-start wrap>
            <v-flex xs12 lg4 class="padding">
                <v-card>
                    <br>
                    <v-avatar v-if="$user.avatarImage" color="grey lighten-4" size="80" v-on="on">
                        <img :src="$user.avatarImage" alt="avatar">
                    </v-avatar>
                    <h2 style="padding: 20px;">{{$user.local.email}}</h2>
                    <v-divider></v-divider>
                        <div style="text-align: left;padding: 20px 50px">
                            <div class="m-nav__link">
                                <v-icon>account_circle</v-icon>
                                <vue-base64-file-upload
                                        class="file-upload-form"
                                        accept="image/png,image/jpeg"
                                        image-class="hidde-image"
                                        input-class="text-pointer"
                                        :placeholder=customTextUploadImage
                                        :max-size="customImageMaxSize"
                                        @size-exceeded="onSizeExceeded"
                                        @file="onFile"
                                        @load="onLoad" />
                            </div>

                            <div class="m-nav__link">
                                <v-icon>account_circle</v-icon>
                                <span class="m-nav__link-text text-pointer" @click="deleteImage">Delete profile image</span>
                            </div>
                        </div>
                    <v-divider></v-divider>
                </v-card>
            </v-flex>
            <v-flex xs12 lg8 class="padding">
                <v-card>
                    <div class="m-portlet__head" style="border-bottom: 1px solid #ebedf2;">
                        <div class="m-portlet__head-caption">
                            <div class="m-portlet__head-title" style="width: 100%">
                                <h3 class="m-portlet__head-text" style="float: initial;text-align: start;padding: 30px;">
                                    {{$t('Update Profile')}}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <v-form style="padding: 30px;">
                        <br>
                        <h3>{{$t('1. Personal Details')}}</h3>
                        <v-text-field prepend-icon="person" name="name" :label="$t('Name')" type="text" v-model="name"></v-text-field>
                        <v-text-field prepend-icon="email" name="email" :rules="[rules.email,rules.empty]" :label="$t('Email')" type="text" v-model="email" ></v-text-field>
                        <v-text-field prepend-icon="vpn_key" name="Public key" :label="$t('PublicKey')" disabled type="text" v-model="pkey"></v-text-field>
                        <br>
                        <h3>{{$t('2. Change Password')}}</h3>
                        <v-text-field prepend-icon="lock_open" name="oldpassword" :label="$t('Old Password')" type="password" v-model="oldpassword"></v-text-field>
                        <v-text-field prepend-icon="lock" name="newpassword" :label="$t('New Password')" type="password" v-model="newpassword"></v-text-field>
                        <v-text-field prepend-icon="lock" name="rnewpassword" :label="$t('Confirm New Password')" type="password" v-model="rnewpassword"></v-text-field>
                        <br>
                        <h3>{{$t('3. Notifications')}}</h3>
                        <p style="text-align: left;">Enable o disable the email notifications by clicking on the following checkbox:</p>
                        <v-checkbox v-model="checkboxMail" color="primary" :label="$t('Notifications by Email')"></v-checkbox>
                        <v-btn color="primary" dark @click="savechanges">{{$t('Save changes')}}</v-btn>
                        <v-btn color="secondary" dark @click="cancel">{{$t('Cancel')}}</v-btn>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import AuthRepository from "@/repositories/AuthRepository";
    import VueBase64FileUpload from 'vue-base64-file-upload';
    import FilesRepository from '@/repositories/FilesRepository'
    import config from "../config"

    import {  VFlex, VCard, VLayout, VDivider, VTextField, VBtn, VForm, VCheckbox, VAvatar, VIcon } from 'vuetify/lib';
    export default {
        name: 'Profile',
        components: {
            VFlex,
            VCard,
            VLayout,
            VDivider,
            VTextField,
            VBtn,
            VForm,
            VCheckbox,
            VAvatar,
            VIcon,
            VueBase64FileUpload
        },
        data() {
            return {
                rules:{
                    empty: value => {
                        return (this.email.length!=0)
                    },
                    email: value => {
                        if(value=='') return true;
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || 'Invalid e-mail.'
                    }
                },
                name: "",
                email: "",
                pkey: "",
                oldpassword:"",
                newpassword:"",
                files:[],
                rnewpassword:"",
                checkboxMail:true,
                customTextUploadImage: "Upload profile image",
                customImageMaxSize: 3 // megabytes
            };
        },
        methods: {
            onFile(file) {
                var files = [];
                files.push(file);
                FilesRepository.uploadProfileImage(files).then(response => {
                    this.status = 'ok';
                    this.$emit('upload-success');
                    location.reload();
                }).catch((error) => {
                    this.errors = (Array.isArray(error.response.data)) ? error.response.data : [error.response.data];
                    this.status = 'error';
                })
            },

            onLoad(dataUri) {

            },

            onSizeExceeded(size) {
                this.snakeError(this.$t('Image ')+size+this.$t('Mb size exceeds limits of ')+this.customImageMaxSize+this.$t('Mb!'));
            },
            deleteImage(){
                var files = [];
                FilesRepository.uploadProfileImage(files).then(() => {
                    this.status = 'ok';
                    this.$emit('upload-success');
                    location.reload();
                }).catch((error) => {
                    this.errors = (Array.isArray(error.response.data)) ? error.response.data : [error.response.data];
                    this.status = 'error';
                })
            },
            clearfields(){
                this.name=this.$user.name;
                this.email=this.$user.local.email;
                this.pkey=this.$user.publicKey;
                this.oldpassword="";
                this.newpassword="";
                this.rnewpassword="";
                this.checkboxMail=this.$user.emailNotifications;
            },
            cancel(){
                this.$router.push({name: 'home'});
            },
            savepassword(){
                if(this.newpassword === this.rnewpassword){
                    AuthRepository.changePassword(this.oldpassword, this.newpassword)
                        .then(() => {
                            this.savepersonaldetails();
                        }).catch((error) => {
                            this.snakeError(error.response.data.message);
                        });
                }else{
                    this.snakeError(this.$t("Passwords doesn't match."));
                }
            },
            savepersonaldetails(){
                if (this.rules.email(this.email) === true) {
                    AuthRepository.savePersonalDetails(this.name, this.email, this.checkboxMail)
                        .then(() => {
                            this.modalSuccess(this.$t('Personal Details'), this.$t('Personal Details saved correctly.'));
                            this.clearfields();
                        }).catch((error) => {
                        this.snakeError(error.response.message);
                    });
                } else {
                    this.snakeError(this.$t('Email not correct'));
                }
            },
            savechanges(){
                if(this.oldpassword !== ""){
                    this.savepassword();
                }else {
                    this.savepersonaldetails();
                }
            },
            snakeSuccess(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'success', timeout: 6000 });
            },
            snakeError(text){
                this.$root.$emit('show-snackbar', {message: text,color: 'error', timeout: 6000 });
            },
            modalSuccess(title ,text){
                this.$root.$emit('show-modal', {title: title,message: text,type: '' });
            },
            modalError(title ,text){
                this.$root.$emit('show-modal', {title: title,message: text,type: 'error' });
            }
        },
        created() {
            this.clearfields();
        }
    };
</script>

<style>
    .padding {
        padding: 20px;
    }
    .hidde-image{
        display: none;
    }
    .file-upload-form{
        display: inline-block;
    }
    .text-pointer{
        cursor: pointer;
    }
    input[type='file']{
        opacity: 0;
        cursor: pointer;
        font-size: 0;
        position: absolute;
    }
</style>
